import { useQuery } from '@tanstack/react-query';
import { settingsService } from '../services/settingsService';

/**
 * Query key factory for settings
 */
export const settingsKeys = {
  all: ['settings'] as const,
  detail: (key: string) => [...settingsKeys.all, key] as const,
};

/**
 * Hook to fetch a specific setting
 */
export function useSetting(key: string) {
  return useQuery({
    queryKey: settingsKeys.detail(key),
    queryFn: () => settingsService.getSetting(key),
  });
}

/**
 * Hook to fetch a boolean setting with default value
 */
export function useBooleanSetting(key: string, defaultValue = false) {
  return useQuery({
    queryKey: settingsKeys.detail(key),
    queryFn: () => settingsService.getBooleanSetting(key, defaultValue),
  });
}

/**
 * Hook to fetch all settings
 */
export function useAllSettings() {
  return useQuery({
    queryKey: settingsKeys.all,
    queryFn: () => settingsService.getAllSettings(),
  });
}
